import { ResourceDefinition } from '@Utils/types';

export const ordersResource: ResourceDefinition = {
  options: { label: 'menu.orders' },
};
